// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__vaiEQ","row":"ProcedureTreatmentSummary_row__2rFOg"};